
export default {
	name: "NYTGamesCard",
	props: {
		to: { type: String, required: true },
		bgColor: { type: String, default: "white" },
		textColor: { type: String, default: "black" },
		title: { type: String, required: true },
		subtitle: { type: String, required: true },
		smallerTitle: { type: Boolean, default: false },
	},
	data() {
		return {
			isHovered: false,
		};
	},
	computed: {
		arrowIconDefault() {
			return require("~/assets/icons/bt-round.svg");
		},
		arrowIconHover() {
			return require("~/assets/icons/bt-round-blue.svg");
		},
	},
};
